if (!customElements.get('newsletter-modal')) {
  customElements.define(
    'newsletter-modal',
    class NewsletterModal extends ModalElement {
      constructor() {
        super();
    
        // Prevent popup on Shopify robot challenge page
        if (window.location.pathname === '/challenge' || !theme.cookiesEnabled) {
          return;
        }
    
        if (!theme.config.isTouch || Shopify.designMode) {
          this.init();
        }
        else {
          new theme.initWhenVisible(theme.utils.throttle(this.init.bind(this)));
        }
      }
    
      get shouldLock() {
        return true;
      }
    
      get testMode() {
        return this.getAttribute('data-test-mode') === 'true';
      }
    
      get delay() {
        return this.hasAttribute('data-delay') ? parseInt(this.getAttribute('data-delay')) : 5;
      }
    
      get expiry() {
        return this.hasAttribute('data-expiry') ? parseInt(this.getAttribute('data-expiry')) : 30;
      }
    
      // Claude 2026-08-10: false on install-/size-guide pages -- the modal still opens
      // from a button there, it just never interrupts on a timer.
      get autoOpen() {
        return this.getAttribute('data-auto-open') !== 'false';
      }
    
      get cookieName() {
        return 'concept:newsletter-popup';
      }
    
      get submited() {
        return this.querySelector('.alert') !== null;
      }
    
      init() {
        if (this.initialized) return;
        this.initialized = true;
        
        // Guide pages own their sign-up inline -- the modal must never take over there,
        // including after a form POST. This check MUST stay above the `submited` branch:
        // with it below, a successful inline sign-up reloaded the page and the modal
        // popped up with a bare "Thanks for subscribing" and no code. (King, 2026-08-10)
        if (!this.autoOpen) return;
    
        // Open modal if errors or success message exist
        if (this.submited) {
          this.load(1);
          return;
        }
    
        if (this.testMode || !this.getCookie(this.cookieName)) {
          this.load(this.delay);
        }
      }
    
      load(delay) {
        if (Shopify.designMode) return;
    
        setTimeout(() => this.show(), delay * 1000);
      }
    
      afterShow() {
        super.afterShow();
        this.classList.add('show-image');
      }
    
      afterHide() {
        super.afterHide();
        this.classList.remove('show-image');
    
        // Remove a cookie in case it was set in test mode
        if (this.testMode) {
          this.removeCookie(this.cookieName);
          return;
        }
    
        this.setCookie(this.cookieName, this.expiry);
      }
    
      getCookie(name) {
        const match = document.cookie.match(`(^|;)\\s*${name}\\s*=\\s*([^;]+)`);
        return match ? match[2] : null;
      }
    
      setCookie(name, expiry) {
        document.cookie = `${name}=true; max-age=${(expiry * 24 * 60 * 60)}; path=/`;
      }
    
      removeCookie(name) {
        document.cookie = `${name}=; max-age=0`;
      }
    }
  );
}

// Hide the floating newsletter bar once the footer scrolls into the bar's
// vertical zone (it sits fixed at 50vh), so it never covers the footer links.
(function () {
  function initNewsletterBarFooterHide() {
    const bar = document.querySelector('.newsletter-bar');
    const footer = document.querySelector('.footer');

    if (!bar || !footer || !('IntersectionObserver' in window)) return;

    const observer = new IntersectionObserver(
      (entries) => {
        bar.classList.toggle('is-at-footer', entries[0].isIntersecting);
      },
      // Shrink the viewport's bottom edge to the vertical middle so the bar
      // only hides once the footer reaches where the bar actually sits.
      { rootMargin: '0px 0px -50% 0px' }
    );

    observer.observe(footer);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initNewsletterBarFooterHide);
  } else {
    initNewsletterBarFooterHide();
  }
})();

// Claude 2026-08-10: mobile 10%-off pill. Mirrors the desktop tab's behaviour --
// appears once past the hero, hides over the footer so it never covers those links.
(function () {
  function initMobileCta() {
    const cta = document.querySelector('.nl-mobile-cta');
    if (!cta) return;

    const footer = document.querySelector('.footer');
    let atFooter = false;

    function update() {
      cta.classList.toggle('is-visible', window.scrollY > 300 && !atFooter);
    }

    if (footer && 'IntersectionObserver' in window) {
      new IntersectionObserver(
        (entries) => {
          atFooter = entries[0].isIntersecting;
          update();
        },
        { rootMargin: '0px 0px -25% 0px' }
      ).observe(footer);
    }

    window.addEventListener('scroll', update, { passive: true });
    update();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMobileCta);
  } else {
    initMobileCta();
  }
})();


// Shopify's chat launcher renders at z-index 2147483000, so it sits over the newsletter
// modal whatever we set -- on mobile it lands squarely on the "Shop now" button. Park it
// while the modal is open.
//
// Driven off the modal's own attributes rather than afterShow()/afterHide(): those hooks
// do not fire on every path that opens this modal, so hooking them silently misses cases.
(function () {
  function initChatParking() {
    var modal = document.getElementById('NewsletterModal');
    if (!modal || !window.MutationObserver) return;

    function sync() {
      var open = !modal.hasAttribute('hidden');
      document.documentElement.classList.toggle('nl-modal-open', open);
    }

    new MutationObserver(sync).observe(modal, { attributes: true, attributeFilter: ['hidden', 'open'] });
    sync();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initChatParking);
  } else {
    initChatParking();
  }
})();


// If a sign-up ever completes via a full page reload rather than the fetch path, the
// visitor lands back on the page with Shopify's bare success alert and no code. Detect
// that on load, promote the inline block to its reward state, and put them back where
// they were instead of at the top of the page. (King, 2026-08-10)
(function () {
  function recoverInlineSignup() {
    var block = document.querySelector('[data-ks-offer]');
    if (!block) return;

    var reward = block.querySelector('[data-newsletter-reward]');
    if (!reward || !reward.hasAttribute('hidden')) return;

    // Shopify renders the success alert into its own Liquid forms, not our raw one,
    // so look page-wide rather than inside the block.
    var success = document.querySelector('.alert--success');
    var flagged = /[?&]customer_posted=true/.test(window.location.search);
    if (!success && !flagged) return;

    var form = block.querySelector('form.newsletter-form');
    if (form) form.setAttribute('hidden', '');
    block.querySelectorAll('[data-ks-prompt]').forEach(function (el) {
      el.setAttribute('hidden', '');
    });

    var shop = reward.querySelector('[data-newsletter-shop]');
    if (shop) {
      var code = reward.getAttribute('data-code') || 'WELCOME10';
      var target = block.getAttribute('data-shop-redirect') || '/collections/all';
      shop.setAttribute('href',
        '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(target));
    }
    reward.removeAttribute('hidden');

    // Drop the stray alert the theme rendered elsewhere on the page.
    if (success && !block.contains(success)) success.remove();

    block.scrollIntoView({ block: 'center' });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', recoverInlineSignup);
  } else {
    recoverInlineSignup();
  }
})();


// After a captcha-challenged (native) signup, the browser returns with
// ?customer_posted=true and the modal auto-reopens showing only the theme's plain
// "Thanks for subscribing" alert -- no code. Promote it to the reward state so the
// captcha path ends the same way as the invisible fetch path (King, 2026-08-10).
// Guide pages never hit this: autoOpen is false there and the inline block's Liquid
// branch renders the reward server-side.
(function () {
  if (!/[?&]customer_posted=true/.test(window.location.search)) return;

  function promote() {
    var modal = document.getElementById('NewsletterModal');
    if (!modal) return;

    var reward = modal.querySelector('[data-newsletter-reward]');
    if (!reward || !reward.hasAttribute('hidden')) return;

    // Only promote when the modal actually carries the success alert -- errors and
    // ordinary opens must keep the form.
    var alertEl = modal.querySelector('.alert--success');
    if (!alertEl) return;

    var form = modal.querySelector('form.newsletter-form');
    if (form) form.setAttribute('hidden', '');
    var social = modal.querySelector('.social-icons');
    if (social) social.setAttribute('hidden', '');

    var shop = reward.querySelector('[data-newsletter-shop]');
    if (shop) {
      var code = reward.getAttribute('data-code') || 'WELCOME10';
      var target = modal.getAttribute('data-shop-redirect') || '/collections/all';
      shop.setAttribute('href',
        '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(target));
    }

    alertEl.remove();
    reward.removeAttribute('hidden');

    // Removing the alert defuses the element's own `submited` auto-open (it looks for
    // `.alert`), so open the modal explicitly -- retrying until the custom element has
    // upgraded, which can land after DOMContentLoaded.
    var tries = 0;
    (function open() {
      if (typeof modal.show === 'function') {
        if (modal.hasAttribute('hidden')) modal.show();
      } else if (++tries < 40) {
        setTimeout(open, 250);
      }
    })();
  }

  function guardedPromote() {
    var modal = document.getElementById('NewsletterModal');
    // Guide pages handle the reveal in their inline block; never resurrect the
    // modal hijack there.
    if (modal && modal.getAttribute('data-auto-open') === 'false') return;
    promote();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', guardedPromote);
  } else {
    guardedPromote();
  }
})();
